import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

// import 'react-pdf/dist/Page/TextLayer.css'
// import 'react-pdf/dist/Page/AnnotationLayer.css'
// import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry'
// pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker

// reset of your code
// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString()
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

const PDFView = ({
    src,
    numPages,
    documentWidth,
    documentHeight,
    setWrapperRef,
    onDocumentLoadSuccess,
    onPageLoadSuccess
}) => {
    return (
        <Box
            ref={setWrapperRef}
            sx={{
                overflow: documentHeight ? 'scroll' : 'unset',
                height: documentHeight,
                py: 7
            }}
        >
            <Document loading={''} file={src} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from({ length: numPages }, (_, index) => (
                    <Box
                        key={`page_${index}`}
                        className="react-pdf__page"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 3,
                            mb: 4
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: 'common.gray.1',
                                borderRadius: 6,
                                display: 'flex',
                                gap: 1,
                                p: '0 12px'
                            }}
                        >
                            <Typography
                                variant="semiBoldBody3"
                                sx={{
                                    color: 'common.blueAccent1.light',
                                    letterSpacing: '1px',
                                    typography: {
                                        xs: 'semiBoldBody3',
                                        md: 'semiBoldBody2'
                                    }
                                }}
                            >
                                {index + 1}
                            </Typography>
                            <Typography
                                variant="lightBody3"
                                sx={{
                                    letterSpacing: '1px',
                                    typography: {
                                        xs: 'lightBody3',
                                        md: 'lightBody2'
                                    }
                                }}
                            >
                                /&nbsp;{numPages}
                            </Typography>
                        </Box>
                        <Page width={documentWidth} pageIndex={index} onLoadSuccess={onPageLoadSuccess} />
                    </Box>
                ))}
            </Document>
        </Box>
    )
}

PDFView.propTypes = {
    src: PropTypes.string,
    numPages: PropTypes.number,
    documentWidth: PropTypes.number,
    documentHeight: PropTypes.number,
    setWrapperRef: PropTypes.func,
    onDocumentLoadSuccess: PropTypes.func,
    onPageLoadSuccess: PropTypes.func
}

export default PDFView
